var map = {
	"./afghanistan.png": 511,
	"./albania.png": 512,
	"./algeria.png": 513,
	"./andalucia.png": 514,
	"./andorra.png": 515,
	"./angola.png": 516,
	"./antiguabarbuda.png": 517,
	"./aragon.png": 518,
	"./argentina.png": 519,
	"./armenia.png": 520,
	"./aruba.png": 521,
	"./asturias.png": 522,
	"./australia.png": 523,
	"./austria.png": 524,
	"./azores.png": 525,
	"./bahamas.png": 526,
	"./bahrain.png": 527,
	"./balearicislands.png": 528,
	"./bangladesh.png": 529,
	"./barbados.png": 530,
	"./basque.png": 531,
	"./belarus.png": 532,
	"./belgium.png": 533,
	"./benin.png": 534,
	"./berkinafaso.png": 535,
	"./bhutan.png": 536,
	"./bosnia.png": 537,
	"./botswana.png": 538,
	"./brazil.png": 539,
	"./bulgaria.png": 540,
	"./burundi.png": 541,
	"./cambodia.png": 542,
	"./cameroon.png": 543,
	"./canada.png": 544,
	"./canaryislands.png": 545,
	"./cantabria.png": 546,
	"./capeverde.png": 547,
	"./catalonia.png": 548,
	"./chad.png": 549,
	"./chile.png": 550,
	"./china.png": 551,
	"./columbia.png": 552,
	"./comoros.png": 553,
	"./costarica.png": 554,
	"./croatia.png": 555,
	"./cyprus.png": 556,
	"./czechrepublic.png": 557,
	"./denmark.png": 558,
	"./dominicanrepublic.png": 559,
	"./ecuador.png": 560,
	"./egypt.png": 561,
	"./elsalvador.png": 562,
	"./england.png": 563,
	"./estonia.png": 564,
	"./ethiopia.png": 565,
	"./faroes.png": 566,
	"./finland.png": 567,
	"./france.png": 568,
	"./frenchpolynesia.png": 569,
	"./gabon.png": 570,
	"./galicia.png": 571,
	"./gambia.png": 572,
	"./germany.png": 573,
	"./ghana.png": 574,
	"./gibraltar.png": 575,
	"./greece.png": 576,
	"./greenland.png": 577,
	"./grenada.png": 578,
	"./guam.png": 579,
	"./guatemala.png": 580,
	"./guinea.png": 581,
	"./haiti.png": 582,
	"./hondoras.png": 583,
	"./hongkong.png": 584,
	"./hungary.png": 585,
	"./iceland.png": 586,
	"./india.png": 587,
	"./indonesia.png": 588,
	"./iran.png": 589,
	"./iraq.png": 590,
	"./ireland.png": 591,
	"./israel.png": 592,
	"./italy.png": 593,
	"./ivorycoast.png": 594,
	"./jacorre.png": 595,
	"./jamaica.png": 596,
	"./japan.png": 597,
	"./jordan.png": 598,
	"./kenya.png": 599,
	"./kiribati.png": 600,
	"./kuwait.png": 601,
	"./laos.png": 602,
	"./latvia.png": 603,
	"./lebanon.png": 604,
	"./liberia.png": 605,
	"./libya.png": 606,
	"./lithuania.png": 607,
	"./luxembourg.png": 608,
	"./macadonia.png": 609,
	"./madagascar.png": 610,
	"./madeira.png": 611,
	"./malawi.png": 612,
	"./malaysia.png": 613,
	"./maldives.png": 614,
	"./mali.png": 615,
	"./malta.png": 616,
	"./mauritania.png": 617,
	"./mauritius.png": 618,
	"./mexico.png": 619,
	"./micronesia.png": 620,
	"./moldova.png": 621,
	"./mongolia.png": 622,
	"./montenegro.png": 623,
	"./morocco.png": 624,
	"./mozambique.png": 625,
	"./navarre.png": 626,
	"./nepal.png": 627,
	"./netherlands.png": 628,
	"./newzealand.png": 629,
	"./nicaragua.png": 630,
	"./niger.png": 631,
	"./nigeria.png": 632,
	"./northernireland.png": 633,
	"./northkorea.png": 634,
	"./norway.png": 635,
	"./oman.png": 636,
	"./pakistan.png": 637,
	"./palau.png": 638,
	"./palestine.png": 639,
	"./panama.png": 640,
	"./peru.png": 641,
	"./phillippines.png": 642,
	"./poland.png": 643,
	"./portugal.png": 644,
	"./puertorico.png": 645,
	"./qatar.png": 646,
	"./romania.png": 647,
	"./russia.png": 648,
	"./rwanda.png": 649,
	"./saintlucia.png": 650,
	"./saudiarabia.png": 651,
	"./scotland.png": 652,
	"./senegal.png": 653,
	"./serbia.png": 654,
	"./sierraleone.png": 655,
	"./singapore.png": 656,
	"./slovakia.png": 657,
	"./slovenia.png": 658,
	"./somalia.png": 659,
	"./southafrica.png": 660,
	"./southkorea.png": 661,
	"./spain.png": 662,
	"./srilanka.png": 663,
	"./swaziland.png": 664,
	"./sweden.png": 665,
	"./switzerland.png": 666,
	"./taiwan.png": 667,
	"./thailand.png": 668,
	"./togo.png": 669,
	"./tonga.png": 670,
	"./trinidadtobago.png": 671,
	"./tunisia.png": 672,
	"./turkey.png": 673,
	"./uganda.png": 674,
	"./ukraine.png": 675,
	"./unitedarabemirates.png": 676,
	"./unitedkingdom.png": 677,
	"./unitednations.png": 678,
	"./uruguay.png": 679,
	"./usa.png": 680,
	"./valencia.png": 681,
	"./venezuela.png": 682,
	"./vietnam.png": 683,
	"./wales.png": 684,
	"./yemen.png": 685,
	"./zambia.png": 686,
	"./zimbabwe.png": 687
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 510;